import * as React from 'react'

const SvgHintIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="16"
    fill="none"
    viewBox="0 0 12 16"
    {...props}
  >
    <path
      stroke="#FF692E"
      d="M4.333 14.667h3.334m-3-8h2.667M6 6.667v4m2-.45a4.667 4.667 0 10-4 0v.45c0 .62 0 .931.102 1.177.135.326.395.586.721.721.245.102.556.102 1.177.102s.932 0 1.177-.102c.327-.135.586-.395.722-.721C8 11.599 8 11.288 8 10.667v-.45z"
    ></path>
  </svg>
)

export default SvgHintIcon
